import { z } from 'zod'

export const schema = z.object({
  destination: z.object({
    name: z.string(),
    slug: z.string(),
    type: z.string(),
    latitude: z.number(),
    longitude: z.number(),
  }),
})

export type schemaType = z.infer<typeof schema>
